const translations = {
    fr: {
      userAccountTitle: "Mon Compte"
    },
    en: {
      userAccountTitle: "My Account"
    },
    de: {
      userAccountTitle: "Mein Konto"
    },
    es: {
      userAccountTitle: "Mi cuenta"
    },
    it: {
      userAccountTitle: "Il mio account"
    }
  };
  
  export default translations;
  